<template>
  <div>
    <div class="title-line"
         style="background-image: linear-gradient(to right, rgba(15, 61, 104, 1), rgba(41, 155, 255, 1));"></div>
    <div style="display: inline-block;margin: 0 20px;"> {{ title }}</div>
    <div class="title-line"
         style="background-image: linear-gradient(to right, rgba(41, 155, 255, 1), rgba(15, 61, 104, 1));"></div>
  </div>
</template>

<script>
export default {
  name: "DialogHeader",
  props: ['title']
}
</script>

<style scoped>
.title-line {
  width: 90px;
  height: 2px;
  display: inline-block;
  margin-bottom: 5px;
  border-radius: 15px;
}

@media (max-width: 1441px) {
  .title-line {
    width: 55px !important;
  }
}
</style>